import { FeatureToggleClientService } from 'feature-toggle-client';
const showWhatsAppGroupViewFeature = 'show-whats-app-group-view';
export class GroupsFeatures {
    static async isShowWhatsAppGroupViewEnabled() {
        return await FeatureToggleClientService
            .getInstance()
            .isFeatureEnabled(showWhatsAppGroupViewFeature, this.showWhatsAppGroupView);
    }
}
GroupsFeatures.showWhatsAppGroupView = false;
